import { AbilityPointScore, AbilityPointStatus } from '@/enums/abilityDimensionEnum'
import { FaqKeywordStatus, FaqKeywordType } from '@/enums/faqKeywordEnum'
import { ShelveTimeUnit, SubmitWay, TeacherResult, TeacherResultOfTest, TeacherStageResult } from '@/enums/pcOperateEnum'
import type { Dict, DictType2dicts } from '@shared/dict'
import { SurveyType } from '@shared/survey'
import { enumToObjectArrayGenerator } from './util'

// 枚举转字典
export const enum2dict = enumToObjectArrayGenerator('dictValue', 'dictKey')
export const enum2dictReverse = enumToObjectArrayGenerator('dictKey', 'dictValue')
export const exFilterByNumberEnum = (dict: Dict | any) => typeof dict.dictKey === 'number'
//*** enum2dictBySpecial该方法是为了应对： 类似KnowledgeStatus 这些 enum value为number的枚举用enum2dict转换后，出现不明多余的Dict情况,所以需要过滤掉
export const enum2dictBySpecial = (enumVal: Parameters<typeof enum2dict>[0]) => enum2dict(enumVal).filter(exFilterByNumberEnum)
export const localDicts: DictType2dicts = {
	HasOrNot: [
		{
			dictValue: '有',
			dictKey: true,
		},
		{
			dictValue: '无',
			dictKey: false,
		},
	],
	YesOrNo: [
		{
			dictValue: '是',
			dictKey: true,
		},
		{
			dictValue: '否',
			dictKey: false,
		},
	],
	TeacherScope: [
		{
			dictValue: '全阶段',
			dictKey: '1',
		},
		{
			dictValue: '分阶段',
			dictKey: '2',
		},
	],
	DataScope: [
		{
			dictValue: '全部教师',
			dictKey: '1',
		},
		{
			dictValue: '自己级别以下',
			dictKey: '2',
		},
		{
			dictValue: '仅自己',
			dictKey: '3',
		},
	],
	// processStatus 进行中:doing;搁置:shelve;完成:finish;已关闭:close
	ProcessStatus: [
		{
			dictValue: '进行中',
			dictKey: 'doing',
		},
		{
			dictValue: '搁置',
			dictKey: 'shelve',
		},
		{
			dictValue: '完成',
			dictKey: 'finish',
		},
		{
			dictValue: '已关闭',
			dictKey: 'close',
		},
	],
	//feedBackType 反馈类型 normal:正常;upgrade:升级
	FeedBackType: [
		{ dictValue: '正常', dictKey: 'normal' },
		{
			dictValue: '升级',
			dictKey: 'upgrade',
		},
	],
	// task leaner stat feedBackType 对接家长类型
	FeedBackTypeWithStat: [
		{ dictValue: '全部', dictKey: 'all' },
		{
			dictValue: '对接家长',
			dictKey: 'butt',
		},
	],
	WordType: enum2dict(FaqKeywordType),
	WordStatus: enum2dict(FaqKeywordStatus),
	ShelveTimeUnit: enum2dictReverse(ShelveTimeUnit),
	SubmitWay: enum2dictReverse(SubmitWay),
	TeacherResult: enum2dictReverse(TeacherResult),
	TeacherResultOfTest: enum2dictReverse(TeacherResultOfTest),
	TeacherStageResult: enum2dictReverse(TeacherStageResult),
	AbilityPointStatus: enum2dict(AbilityPointStatus),
	AbilityPointScore: enum2dictBySpecial(AbilityPointScore) as Dict[],
	SurveyTypeLocal: enum2dictReverse(SurveyType),
	// AuditStatus 审核状态: 0-待审核, 1-审核通过, 2-审核拒绝
	AuditStatus: [
		{ dictValue: '待审核', dictKey: '0' },
		{ dictValue: '审核通过', dictKey: '1' },
		{ dictValue: '审核拒绝', dictKey: '2' },
	],
	// UserType 用户类型: 1-家长, 2-管理员, 3-教师
	UserType: [
		{ dictValue: '家长', dictKey: '1' },
		{ dictValue: '管理员', dictKey: '2' },
		{ dictValue: '教师', dictKey: '3' },
	],
}
